import { CachedContentArea } from '@components';
import { HeaderBlockPlaceholder } from '@components/blocks/navigation/HeaderBlock/HeaderBlock';
import { useAppSelector } from '@hooks';
import { getHeaderContentArea, isHeaderContentLoaded } from '@store/app/app.slice';

export const HeaderContentArea = () => {
  const isLoaded = useAppSelector(isHeaderContentLoaded);
  return isLoaded ? (
    <CachedContentArea selector={getHeaderContentArea} contentAreaName='HeaderContent' />
  ) : (
    <HeaderBlockPlaceholder />
  );
};
